import {
  CookieCategory,
  destroyBrowserCookie,
  getBrowserCookie,
  setBrowserCookie,
  useOneTrustConsentCategory,
} from '@moonpig/web-core-browser-storage'
import { useEffect } from 'react'

type CacheEppoCustomerIdProps = {
  customerId: string | null
  isLoggedIn: boolean
}

type CacheEppoCustomerId = (props: CacheEppoCustomerIdProps) => null

export const CacheEppoCustomerId: CacheEppoCustomerId = ({
  customerId,
  isLoggedIn,
}) => {
  const userHasConsented = useOneTrustConsentCategory(CookieCategory.FUNCTIONAL)

  useEffect(() => {
    if (userHasConsented && isLoggedIn) {
      const cachedCustomerId = getBrowserCookie('mnpg_eppo_customer_id')

      if (!cachedCustomerId && customerId) {
        setBrowserCookie(
          'mnpg_eppo_customer_id',
          customerId,
          { maxAge: 3600, path: '/' }, // 1 hour in seconds
          CookieCategory.FUNCTIONAL,
        )
      }
    }
  }, [customerId, isLoggedIn, userHasConsented])

  return null
}

export const removeEppoCustomerIdCookie = () => {
  destroyBrowserCookie('mnpg_eppo_customer_id', { path: '/' })
}
